const TorrentRoutes = {
  yts: `/yts/`,
  piratebay: `/piratebay/200/`,
  x1337: `/1337x/false/`,
};

export default TorrentRoutes;
